module.exports = __webpack_public_path__ + "img/lx_code.378ed684.png";